"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnExpand = void 0;
var react_1 = require("react");
var useOnExpand = function (
/** Value from Option. Accepts an array of any content */
value) {
    var getValue = Array.isArray(value) ? value : [value];
    var _a = react_1.useState(__spreadArray([], getValue)), expandValue = _a[0], setExpandValue = _a[1];
    var setCollapseValue = function (data) {
        expandValue.includes(data)
            ? setExpandValue(function (prevState) {
                return __spreadArray([], prevState).filter(function (item) { return item !== data; });
            })
            : setExpandValue(function (prevState) { return __spreadArray(__spreadArray([], prevState), [data]); });
        return expandValue;
    };
    return [expandValue, setCollapseValue];
};
exports.useOnExpand = useOnExpand;
//# sourceMappingURL=useOnExpand.js.map